import { put, takeLatest } from "redux-saga/effects";
import { getGiftExchangePointApi } from "store/api/GiftExchangeApi";
import { GET_GIFT_EXCHANGE_POINT_ACTION } from "../../actions/GiftExchangePageAction/actionTypes";

import * as giftExchangePageAction from "../../actions/GiftExchangePageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getGiftExchangePoint(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getGiftExchangePointApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(
				giftExchangePageAction.setGiftExchangePointAction(res?.data)
			);
		} else {
			yield put(giftExchangePageAction.setGiftExchangePointAction({}));
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getGiftExchangePointSaga() {
	yield takeLatest(GET_GIFT_EXCHANGE_POINT_ACTION, getGiftExchangePoint);
}

export default getGiftExchangePointSaga;
